export const CONTACT_DATA_ERROR =
  'Сообщение не может содержать контактные данные (телефон, email, ссылки или ники в мессенджерах). Обмен контактами доступен через кнопку "Поделиться контактами".';

const PHONE_PATTERNS = [
  /(?<!\d)(?:\+7|8|7)[\s\-().]*(?:\d[\s\-().]*){10}(?!\d)/i,
  /(?<!\d)(?:\d[\s\-().]){10,14}\d(?!\d)/,
];

const EMAIL_PATTERN = /[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/i;

const URL_PATTERNS = [
  /https?:\/\/[^\s]+/i,
  /\bwww\.[^\s]+\.[a-z]{2,}\b/i,
  /\b(?:[a-z0-9](?:[a-z0-9\-]{0,61}[a-z0-9])?\.)+(?:ru|com|net|org|io|me|pro|info|biz|online|site|app|dev|tech|store|shop|club|live|xyz|cc|su|рф)(?:\/[^\s]*)?\b/i,
];

const MESSENGER_PATTERNS = [
  /(?:t\.me|telegram\.me|telegram\.org)\/[^\s]+/i,
  /(?:wa\.me|whatsapp\.com|api\.whatsapp\.com)\/[^\s]+/i,
  /(?:vk\.com|vk\.me|vkontakte\.ru)\/[^\s]+/i,
  /(?:instagram\.com|instagr\.am)\/[^\s]+/i,
  /(?:facebook\.com|fb\.com|fb\.me)\/[^\s]+/i,
  /(?<![\w@])@[a-zA-Z][a-zA-Z0-9_]{4,31}\b/,
  /\b(?:telegram|whatsapp|viber|skype|discord|instagram|вконтакте|вк|телеграм|ватсап|вотсап)\s*[:@]\s*\S+/i,
];

export const containsContactData = (text: string): boolean => {
  const normalized = text.trim();
  if (!normalized) return false;

  if (PHONE_PATTERNS.some((p) => p.test(normalized))) return true;
  if (EMAIL_PATTERN.test(normalized)) return true;
  if (URL_PATTERNS.some((p) => p.test(normalized))) return true;
  if (MESSENGER_PATTERNS.some((p) => p.test(normalized))) return true;
  return false;
};

export const validateChatMessageText = (text: string): string | null => {
  if (containsContactData(text)) {
    return CONTACT_DATA_ERROR;
  }
  return null;
};

export const REVIEW_COMMENT_MAX_LENGTH = 500;

export const REVIEW_CONTACT_DATA_ERROR =
  'Отзыв не может содержать контактные данные (телефон, email, ссылки или ники в мессенджерах).';

export const validateReviewCommentText = (text: string): string | null => {
  if (text.length > REVIEW_COMMENT_MAX_LENGTH) {
    return `Комментарий не должен превышать ${REVIEW_COMMENT_MAX_LENGTH} символов.`;
  }
  if (containsContactData(text)) {
    return REVIEW_CONTACT_DATA_ERROR;
  }
  return null;
};
